<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row d-flex justify-content-between">
          <div class="col-md-8">
            <b-card-title>
              <h5 class="card-title mb-3">
                Dados referentes ao Lote - {{ sq_astec_integracao_lote }},
                sequência - {{ sq_astec_integracao_item }}
              </h5>
            </b-card-title>
          </div>
        </div>

        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="Cooperativa"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_cooperativa"
                :disabled="true"
                placeholder=""
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="N° Projeto"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_nr_projeto"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Cliente Rural"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_produtor_rural"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="CPF/CNPJ" invalid-feedback="Campo obrigatório">
              <b-form-input
                v-mask="formataCpfCnpj"
                v-model="ds_cpf_cnpj"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="Linha de Crédito"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_enquadramento"
                :disabled="true"
                placeholder=""
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Modalidade de seguro"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_modalidade_seguro"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Item Agropecuário"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_cultura"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="Safra" invalid-feedback="Campo obrigatório">
              <b-form-input
                v-model="ds_safra"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="Astec financiada"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_astec_financiada"
                :disabled="true"
                placeholder=""
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="% Astec" invalid-feedback="Campo obrigatório">
              <b-form-input
                :disabled="true"
                placeholder="Selecione"
                v-model="vl_per_astec_display"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Município"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="ds_cidade"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="UF" invalid-feedback="Campo obrigatório">
              <b-form-input
                v-model="ds_uf"
                :disabled="true"
                placeholder="Selecione"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      sq_astec_integracao_lote: null,
      sq_astec_integracao_item: null,
      ds_cooperativa: null,
      ds_nr_projeto: null,
      ds_produtor_rural: null,
      ds_cpf_cnpj: null,
      ds_enquadramento: null,
      ds_modalidade_seguro: null,
      ds_cultura: null,
      ds_safra: null,
      ds_astec_financiada: null,
      vl_per_astec: null,
      vl_per_astec_display: "",
      ds_cidade: null,
      ds_uf: null
    };
  },

  created() {
    this.preencherCampos();
  },

  methods: {
    preencherCampos() {
      const importacao = this.$store.state.projetoAstec;

      this.sq_astec_integracao_lote = importacao.SQ_ASTEC_INTEGRACAO_LOTE;
      this.sq_astec_integracao_item = importacao.SQ_ASTEC_INTEGRACAO_ITEM;
      this.ds_cooperativa = importacao.DS_COOPERATIVA;
      this.ds_nr_projeto = importacao.DS_NR_PROJETO;
      this.ds_produtor_rural = importacao.DS_PRODUTOR_RURAL;
      this.ds_cpf_cnpj = importacao.DS_CPF_CNPJ;
      this.ds_enquadramento = importacao.DS_ENQUADRAMENTO;
      this.ds_modalidade_seguro = importacao.DS_MODALIDADE_SEGURO;
      this.ds_cultura = importacao.DS_CULTURA;
      this.ds_safra = importacao.DS_SAFRA;
      this.ds_astec_financiada = importacao.DS_ASTEC_FINANCIADA;

      this.vl_per_astec = importacao.PER_ASTEC;
      this.vl_per_astec_display = this.formatarPercentual(importacao.PER_ASTEC);

      this.ds_cidade = importacao.DS_CIDADE;
      this.ds_uf = importacao.DS_UF;
    },

    formatarPercentual(valor) {
      if (!valor && valor !== 0) return "0,00 %";

      let num = 0;
      if (typeof valor === "number") {
        num = valor;
      } else {
        const str = valor.toString().replace(",", ".");
        num = parseFloat(str) || 0;
      }
      return num.toFixed(2).replace(".", ",") + " %";
    }
  },

  computed: {
    formataCpfCnpj() {
      if (!this.ds_cpf_cnpj) return "###.###.###-##";
      return this.ds_cpf_cnpj.length <= 14
        ? "###.###.###-##"
        : "##.###.###/####-##";
    }
  }
};
</script>
